import { render, staticRenderFns } from "./distributeDocument.vue?vue&type=template&id=27f66e4b&"
import script from "./distributeDocument.vue?vue&type=script&lang=js&"
export * from "./distributeDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports